import React from 'react'
import { graphql } from 'gatsby';
import styled from 'styled-components'
import Layout from '../components/layout'

const Table = styled.table`
  line-height: 1rem;
`;

const Th = styled.th`
  width: 33%;
`;

const Td = styled.td`
  width: 33%;
`;

const printDateKey = (dateKey) => {
  const [year, month] = dateKey.split('_');
  return `平成${year}年${month}月`;
};

const convertTable = (tfidfs) => {
  const docNum = tfidfs.length;
  const wordNum = tfidfs[0].words.length;
  const tables = [];
  let table = []; 
  for(let i = 0; i < docNum; i++) {
    if(i % 3 === 0 && i !== 0) {
      table.push([tfidfs[i-3].dateKey, tfidfs[i-2].dateKey, tfidfs[i-1].dateKey]);
      for(let j = 0; j < wordNum; j++) {
        table.push([tfidfs[i-3].words[j].word, tfidfs[i-2].words[j].word, tfidfs[i-1].words[j].word]);
      }
      tables.push(table);
      table = [];
    } 
  }
  return tables; 
};

const IndexPage = ({data}) => {
  return (
    <Layout>
      <h2>言葉から見る柏</h2>
      <p>インターネットに公開されているH11年第3回の定例会以降の議会議事録を解析した結果です。</p>
      <p>各会ごとに特徴的な単語上位20件を表示しています。 </p>
      <div>
        {
          convertTable(data.internalTfidfs.tfidfs.reverse()).map((table, i) => {
            return (
              <Table key={i}>
                <thead>
                  <tr>
                    {
                      table[0].map((header) => { return <Th key={header}>{printDateKey(header)}</Th>; })  
                    }
                  </tr>
                </thead>
                <tbody>
                  {
                    table.slice(1).map((line, j) => {
                      return (
                        <tr key={j}>
                          {
                            line.map((word, k) => { return <Td key={`${k}-${word}`}>{word}</Td>; })
                          }
                        </tr>
                      );
                    })
                  }
                  </tbody>
                </Table>
            );
          })
        }
      </div>
    </Layout>
  );
};

export default IndexPage;

export const query = graphql`
  query {
    internalTfidfs {
      tfidfs {
        dateKey
        words {
          word
        }
      }
    }
  }
`;